<template>
  <AisCurrentRefinements
    :class-names="{
      'ais-CurrentRefinements': 'FiltersSelected',
    }"
  >
    <template #default="{ items }">
      <template v-if="items.length">
        <div class="FiltersSelected__wrapper">
          <AisClearRefinements>
            <template #default="{ canRefine, refine }">
              <div class="FiltersSelected__clear-all-btn--desktop">
                <VisionButton
                  v-if="canRefine"
                  size="xx-small"
                  @click.prevent="refine(), trackClearAllClick()"
                >
                  <template #content>
                    <span class="FilterSelected__clear-all-text">
                      <VisionIcon
                        icon="cross"
                        colour="black"
                        size="xx-small"
                      />
                      Clear all
                    </span>
                  </template>
                </VisionButton>
              </div>
              <div class="FiltersSelected__clear-all-btn--mobile">
                <VisionButton
                  v-if="canRefine"
                  size="x-small"
                  @click.prevent="refine(), trackClearAllClick()"
                >
                  <template #content>
                    <span class="FilterSelected__clear-all-text">
                      <VisionIcon
                        icon="cross"
                        colour="black"
                        size="xx-small"
                      />
                      Clear all
                    </span>
                  </template>
                </VisionButton>
              </div>
            </template>
          </AisClearRefinements>
          <ul
            v-for="item in items"
            :key="item.value"
            class="FiltersSelected__container"
          >
            <li
              v-for="refinement in item.refinements"
              :key="refinement.value"
            >
              <a
                class="ListRefinement__item-content"
                @click.prevent="item.refine(refinement), trackRefinementClick(refinement)"
              >
                <FilterItem :item="refinement" />
              </a>
            </li>
          </ul>
        </div>
      </template>
    </template>
  </AisCurrentRefinements>
</template>

<script setup>
const { $track } = useNuxtApp()

async function trackClearAllClick() {
  await $track.filter.clearAllFilters()
}

async function trackRefinementClick(refinement) {
  await $track.filter.clearFilter({
    filterText: refinement.label
  })
}
</script>

<style lang="postcss">
.FiltersSelected__wrapper {
  @apply flex gap-3 mt-10;
}

.FiltersSelected__container {
  @apply flex gap-3;
}

.FilterSelected__clear-all-text {
  @apply flex items-center gap-x-1;
}

.FiltersSelected__clear-all-btn--desktop {
  @apply hidden lg:flex;
}

.FiltersSelected__clear-all-btn--mobile {
  @apply flex lg:hidden;
}
</style>
